import React from 'react';
import Modal from 'react-modal';

const BookCancelFinModal = ({ isOpen, message, onConfirm, onClose, disabled, bookDate, count, refundTotal, siteId, entry_name, entrynote, entryName, Total, ticketName, ticketDetail }) => {
  const handleConfirm = () => {
    onConfirm();
  };

  const modalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: "rgba(0,0,0,0.5)",
      zIndex: 1000
    },
    content: {
      position: "absolute",
      left: '50%',
      top: '1%',
      transform: 'translate(-50%, 0)',
      padding: "20px",
      width: '85%',
      height: '60%',
      minHeight: '386px',
      borderRadius: '10px',
      boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
      overflowX: "hidden",
      pointerEvents: "auto",
      backgroundClip: "padding-box",
      border: "1px rgba(0,0,0,.2)",
      margin: '0'
    }
  };

  return (
    <Modal isOpen={isOpen} onRequestClose={onClose} style={modalStyle}>
      <div className="d-flex flex-column align-items-center justify-content-center" style={{ height: '100%' }}>
        <div>
          <div className='text-center text-primary h5 font-weight-bold'>予約をキャンセルしました</div>
          <div className='text-center ml-3'>またのご利用をお待ちしております。</div>
        </div>
        <React.Fragment>
          <div className="mx-0 text-center form-group pt-3 w-100">
            <div className="frame74">
              <div className="row mx-0 text-center pt-3">
                <div className="col-5 text-left small">チケット</div>
                <div className="col-7 text-right small">{ticketName}</div>
              </div>
              <div className="row mx-0 text-center">
                <div className="col-5 text-left small mt-3">利用数</div>
                <div className="col-7 text-right small mt-3">{count}名</div>
              </div>
              <div className='ticketconfirm-border m-2'></div>
              <div className="row mx-0 text-center small mt-1">
                <div className="col-5 text-left">キャンセル料</div>
                <div className="col-7 text-right">&yen;100</div>
              </div>
              <div className="row mx-0 text-center small mt-1">
                <div className="col-5 text-left mb-3">払い戻し額</div>
                <div className="col-7 text-right mb-3">&yen;{Math.floor(Total-100).toLocaleString()}</div>
              </div>
            </div>
          </div>
        </React.Fragment>
        <div>
          <button className='btn cancelfinbutton mt-3 p-3 w-100' onClick={handleConfirm} disabled={disabled}>TOPへ</button>
        </div>
      </div>
    </Modal>
  );
};

export default BookCancelFinModal;